module.exports = __webpack_public_path__ + "img/month_pay.5734c12b.png";